import React from 'react';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    withStyles,
} from 'material-ui';
import {styles} from '../../style/url_popup';

const ProductTagosIdPopup = ({
    open,
    classes,
    productTagosId,
    onUpdateProductTagosIdField,
    onHandleSubmit,
    onHandleClose,
}) => {
    return (
        <EditDialog
            open={open}
            classes={{
                paper: classes.paperDialog,
                fullWidth: classes.smallPopup,
            }}
        >
            <DialogTitle>Edit Product Tagos ID</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="productTagosId"
                    label="Product Tagos ID"
                    value={productTagosId}
                    onChange={(event) => {
                        onUpdateProductTagosIdField(
                            parseInt(event.target.value, 10)
                        );
                    }}
                    type="number"
                    helperText="Only numbers accepted"
                    InputProps={{inputProps: {min: 0}}}
                    fullWidth
                />
            </DialogContent>
            <DialogActions className={classes.dialogActionsBtn}>
                <Button variant="raised" onClick={(ev) => onHandleClose(ev)}>
                    Cancel
                </Button>
                <Button
                    variant="raised"
                    onClick={(ev) => onHandleSubmit(ev)}
                    color="primary"
                >
                    Done
                </Button>
            </DialogActions>
        </EditDialog>
    );
};

export default withStyles(styles)(ProductTagosIdPopup);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/product_tagos_id_popup.js